import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  Globe, Cloud, ShieldCheck,
  GraduationCap, HeartPulse, Factory, ShoppingCart, Truck, Coins,
  Building2, Users, Target, Boxes, Puzzle,
  Code2, MonitorSmartphone, Cpu, Headphones,
  ArrowRight, ChevronRight,
  Search, Bell, Settings, LayoutGrid, CalendarDays, BookOpen, Bus, FileText, UserSquare2,
} from 'lucide-react';

/* ============================== BRAND LOGOS (official SVG paths) ============================== */

const PATHS = {
  react: 'M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z',
  next: 'M18.665 21.978C16.758 23.255 14.465 24 12 24 5.377 24 0 18.623 0 12S5.377 0 12 0s12 5.377 12 12c0 3.583-1.574 6.801-4.067 9.001L9.219 7.2H7.2v9.596h1.615V9.251l9.85 12.727Zm-3.332-8.533 1.6 2.061V7.2h-1.6v6.245Z',
  node: 'M11.998,24c-0.321,0-0.641-0.084-0.922-0.247l-2.936-1.737c-0.438-0.245-0.224-0.332-0.08-0.383 c0.585-0.203,0.703-0.25,1.328-0.604c0.065-0.037,0.151-0.023,0.218,0.017l2.256,1.339c0.082,0.045,0.197,0.045,0.272,0l8.795-5.076 c0.082-0.047,0.134-0.141,0.134-0.238V6.921c0-0.099-0.053-0.192-0.137-0.242l-8.791-5.072c-0.081-0.047-0.189-0.047-0.271,0 L3.075,6.68C2.99,6.729,2.936,6.825,2.936,6.921v10.15c0,0.097,0.054,0.189,0.139,0.235l2.409,1.392 c1.307,0.654,2.108-0.116,2.108-0.89V7.787c0-0.142,0.114-0.253,0.256-0.253h1.115c0.139,0,0.255,0.112,0.255,0.253v10.021 c0,1.745-0.95,2.745-2.604,2.745c-0.508,0-0.909,0-2.026-0.551L2.28,18.675c-0.57-0.329-0.922-0.945-0.922-1.604V6.921 c0-0.659,0.353-1.275,0.922-1.603l8.795-5.082c0.557-0.315,1.296-0.315,1.848,0l8.794,5.082c0.57,0.329,0.924,0.944,0.924,1.603 v10.15c0,0.659-0.354,1.273-0.924,1.604l-8.794,5.078C12.643,23.916,12.324,24,11.998,24z M19.099,13.993 c0-1.9-1.284-2.406-3.987-2.763c-2.731-0.361-3.009-0.548-3.009-1.187c0-0.528,0.235-1.233,2.258-1.233 c1.807,0,2.473,0.389,2.747,1.607c0.024,0.115,0.129,0.199,0.247,0.199h1.141c0.071,0,0.138-0.031,0.186-0.081 c0.048-0.054,0.074-0.123,0.067-0.196c-0.177-2.098-1.571-3.076-4.388-3.076c-2.508,0-4.004,1.058-4.004,2.833 c0,1.925,1.488,2.457,3.895,2.695c2.88,0.282,3.103,0.703,3.103,1.269c0,0.983-0.789,1.402-2.642,1.402 c-2.327,0-2.839-0.584-3.011-1.742c-0.02-0.124-0.126-0.215-0.253-0.215h-1.137c-0.141,0-0.254,0.112-0.254,0.253 c0,1.482,0.806,3.248,4.655,3.248C17.501,17.007,19.099,15.91,19.099,13.993z',
  flutter: 'M14.314 0L2.3 12 6 15.7 21.684.013h-7.357zm.014 11.072L7.857 17.53l6.47 6.47H21.7l-6.46-6.468 6.46-6.46h-7.37z',
  mysql: 'M16.405 5.501c-.115 0-.193.014-.274.033v.013h.014c.054.104.146.18.214.273.054.107.1.214.154.32l.014-.015c.094-.066.14-.172.14-.333-.04-.047-.046-.094-.08-.14-.04-.067-.126-.1-.18-.153zM5.77 18.695h-.927a50.854 50.854 0 00-.27-4.41h-.008l-1.41 4.41H2.45l-1.4-4.41h-.01a72.892 72.892 0 00-.195 4.41H0c.055-1.966.192-3.81.41-5.53h1.15l1.335 4.064h.008l1.347-4.064h1.095c.242 2.015.384 3.86.428 5.53zm4.017-4.08c-.378 2.045-.876 3.533-1.492 4.46-.482.716-1.01 1.073-1.583 1.073-.153 0-.34-.046-.566-.138v-.494c.11.017.24.026.386.026.268 0 .483-.075.647-.222.197-.18.295-.382.295-.605 0-.155-.077-.47-.23-.944L6.23 14.615h.91l.727 2.36c.164.536.233.91.205 1.123.4-1.064.678-2.227.835-3.483zm12.325 4.08h-2.63v-5.53h.885v4.85h1.745zm-3.32.135l-1.016-.5c.09-.076.177-.158.255-.25.433-.506.648-1.258.648-2.253 0-1.83-.718-2.746-2.155-2.746-.704 0-1.254.232-1.65.697-.43.508-.646 1.256-.646 2.245 0 .972.19 1.686.574 2.14.35.41.877.615 1.583.615.264 0 .506-.033.725-.098l1.325.772.36-.622zM15.5 17.588c-.225-.36-.337-.94-.337-1.736 0-1.393.424-2.09 1.27-2.09.443 0 .77.167.977.5.224.362.336.936.336 1.723 0 1.404-.424 2.108-1.27 2.108-.445 0-.77-.167-.978-.5zm-1.658-.425c0 .47-.172.856-.516 1.156-.344.3-.803.45-1.384.45-.543 0-1.064-.172-1.573-.515l.237-.476c.438.22.833.328 1.19.328.332 0 .593-.073.783-.22a.754.754 0 00.3-.615c0-.33-.23-.61-.648-.845-.388-.213-1.163-.657-1.163-.657-.422-.307-.632-.636-.632-1.177 0-.45.157-.81.47-1.085.315-.278.72-.415 1.22-.415.512 0 .98.136 1.4.41l-.213.476a2.726 2.726 0 00-1.064-.23c-.283 0-.502.068-.654.206a.685.685 0 00-.248.524c0 .328.234.61.666.85.393.215 1.187.67 1.187.67.433.305.648.63.648 1.168zm9.382-5.852c-.535-.014-.95.04-1.297.188-.1.04-.26.04-.274.167.055.053.063.14.11.214.08.134.218.313.346.407.14.11.28.216.427.31.26.16.555.255.81.416.145.094.293.213.44.313.073.05.12.14.214.172v-.02c-.046-.06-.06-.147-.105-.214-.067-.067-.134-.127-.2-.193a3.223 3.223 0 00-.695-.675c-.214-.146-.682-.35-.77-.595l-.013-.014c.146-.013.32-.066.46-.106.227-.06.435-.047.67-.106.106-.027.213-.06.32-.094v-.06c-.12-.12-.21-.283-.334-.395a8.867 8.867 0 00-1.104-.823c-.21-.134-.476-.22-.697-.334-.08-.04-.214-.06-.26-.127-.12-.146-.19-.34-.275-.514a17.69 17.69 0 01-.547-1.163c-.12-.262-.193-.523-.34-.763-.69-1.137-1.437-1.826-2.586-2.5-.247-.14-.543-.2-.856-.274-.167-.008-.334-.02-.5-.027-.11-.047-.216-.174-.31-.235-.38-.24-1.364-.76-1.644-.072-.18.434.267.862.422 1.082.115.153.26.328.34.5.047.116.06.235.107.356.106.294.207.622.347.897.073.14.153.287.247.413.054.073.146.107.167.227-.094.136-.1.334-.154.5-.24.757-.146 1.693.194 2.25.107.166.362.534.703.393.3-.12.234-.5.32-.835.02-.08.007-.133.048-.187v.015c.094.188.188.367.274.555.206.328.566.668.867.895.16.12.287.328.487.402v-.02h-.015c-.043-.058-.1-.086-.154-.133a3.445 3.445 0 01-.35-.4 8.76 8.76 0 01-.747-1.218c-.11-.21-.202-.436-.29-.643-.04-.08-.04-.2-.107-.24-.1.146-.247.273-.32.453-.127.288-.14.642-.188 1.01-.027.007-.014 0-.027.014-.214-.052-.287-.274-.367-.46-.2-.475-.233-1.238-.06-1.785.047-.14.247-.582.167-.716-.042-.127-.174-.2-.247-.303a2.478 2.478 0 01-.24-.427c-.16-.374-.24-.788-.414-1.162-.08-.173-.22-.354-.334-.513-.127-.18-.267-.307-.368-.52-.033-.073-.08-.194-.027-.274.014-.054.042-.075.094-.09.088-.072.335.022.422.062.247.1.455.194.662.334.094.066.195.193.315.226h.14c.214.047.455.014.655.073.355.114.675.28.962.46a5.953 5.953 0 012.085 2.286c.08.154.115.295.188.455.14.33.313.663.455.982.14.315.275.636.476.897.1.14.502.213.682.286.133.06.34.115.46.188.23.14.454.3.67.454.11.076.443.243.463.378z',
  mongodb: 'M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296.604-.463.85-.693a11.342 11.342 0 003.639-8.464c.01-.814-.103-1.662-.197-2.218zm-5.336 8.195s0-8.291.275-8.29c.213 0 .49 10.695.49 10.695-.381-.045-.765-1.76-.765-2.405z',
  android: 'M18.4395 5.5586c-.675 1.1664-1.352 2.3318-2.0274 3.498-.0366-.0155-.0742-.0286-.1113-.043-1.8249-.6957-3.484-.8-4.42-.787-1.8551.0185-3.3544.4643-4.2597.8203-.084-.1494-1.7526-3.021-2.0215-3.4864a1.1451 1.1451 0 0 0-.1406-.1914c-.3312-.364-.9054-.4859-1.379-.203-.475.282-.7136.9361-.3886 1.5019 1.9466 3.3696-.0966-.2158 1.9473 3.3593.0172.031-.4946.2642-1.3926 1.0177C2.8987 12.176.452 14.772 0 18.9902h24c-.119-1.1108-.3686-2.099-.7461-3.0683-.7438-1.9118-1.8435-3.2928-2.7402-4.1836a12.1048 12.1048 0 0 0-2.1309-1.6875c.6594-1.122 1.312-2.2559 1.9649-3.3848.2077-.3615.1886-.7956-.0079-1.1191a1.1001 1.1001 0 0 0-.8515-.5332c-.5225-.0536-.9392.3128-1.0488.5449zm-.0391 8.461c.3944.5926.324 1.3306-.1563 1.6503-.4799.3197-1.188.0985-1.582-.4941-.3944-.5927-.324-1.3307.1563-1.6504.4727-.315 1.1812-.1086 1.582.4941zM7.207 13.5273c.4803.3197.5506 1.0577.1563 1.6504-.394.5926-1.1038.8138-1.584.4941-.48-.3197-.5503-1.0577-.1563-1.6504.4008-.6021 1.1087-.8106 1.584-.4941z',
  apple: 'M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701',
  typescript: 'M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z',
  androidstudio: 'M19.2693 10.3368c-.3321 0-.6026.2705-.6026.6031v9.8324h-1.7379l-3.3355-6.9396c.476-.5387.6797-1.286.5243-2.0009a2.2862 2.2862 0 0 0-1.2893-1.6248v-.8124c.0121-.2871-.1426-.5787-.4043-.7407-.1391-.0825-.2884-.1234-.4402-.1234a.8478.8478 0 0 0-.4318.1182c-.2701.1671-.4248.4587-.4123.7662l-.0003.721c-1.0149.3668-1.6619 1.4153-1.4867 2.5197a2.282 2.282 0 0 0 .5916 1.2103l-3.2096 6.9064H4.0928c-1.0949-.007-1.9797-.8948-1.9832-1.9896V5.016c-.0055 1.1024.8836 2.0006 1.9859 2.0062a2.024 2.024 0 0 0 .1326-.0037h14.7453s2.5343-.2189 2.8619 1.5392c-.2491.0287-.4449.2321-.4449.4889 0 .7115-.5791 1.2901-1.3028 1.2901h-.8183zM17.222 22.5366c.2347.4837.0329 1.066-.4507 1.3007-.1296.0629-.2666.0895-.4018.0927a.9738.9738 0 0 1-.3194-.0455c-.024-.0078-.046-.0209-.0694-.0305a.9701.9701 0 0 1-.2277-.1321c-.0247-.0192-.0495-.038-.0724-.0598-.0825-.0783-.1574-.1672-.21-.2757l-1.2554-2.6143-1.5585-3.2452a.7725.7725 0 0 0-.6995-.4443h-.0024a.792.792 0 0 0-.7083.4443l-1.5109 3.2452-1.2321 2.6464a.9722.9722 0 0 1-.7985.5795c-.0626.0053-.1238-.0024-.185-.0087-.0344-.0036-.069-.0053-.1025-.0124-.0489-.0103-.0954-.0278-.142-.0452-.0301-.0113-.0613-.0197-.0901-.0339-.0496-.0244-.0948-.0565-.1397-.0889-.0217-.0156-.0457-.0275-.0662-.045a.9862.9862 0 0 1-.1695-.1844.9788.9788 0 0 1-.0708-.9852l.8469-1.8223 3.2676-7.0314a1.7964 1.7964 0 0 1-.7072-1.1637c-.1555-.9799.5129-1.9003 1.4928-2.0559V9.3946a.3542.3542 0 0 1 .1674-.3155.3468.3468 0 0 1 .3541 0 .354.354 0 0 1 .1674.3155v1.159l.0129.0064a1.8028 1.8028 0 0 1 1.2878 1.378 1.7835 1.7835 0 0 1-.6439 1.7836l3.3889 7.0507.8481 1.7643zM12.9841 12.306c.0042-.6081-.4854-1.1044-1.0935-1.1085a1.1204 1.1204 0 0 0-.7856.3219 1.101 1.101 0 0 0-.323.7716c-.0042.6081.4854 1.1044 1.0935 1.1085h.0077c.6046 0 1.0967-.488 1.1009-1.0935zm-1.027 5.2768c-.1119.0005-.2121.0632-.2571.1553l-1.4127 3.0342h3.3733l-1.4564-3.0328a.274.274 0 0 0-.2471-.1567zm8.1432-6.7459l-.0129-.0001h-.8177a.103.103 0 0 0-.103.103v12.9103a.103.103 0 0 0 .0966.103h.8435c.9861-.0035 1.7836-.804 1.7836-1.79V9.0468c0 .9887-.8014 1.7901-1.7901 1.7901zM2.6098 5.0161v.019c.0039.816.6719 1.483 1.4874 1.4869a12.061 12.061 0 0 1 .1309-.0034h1.1286c.1972-1.315.7607-2.525 1.638-3.4859H4.0993c-.9266.0031-1.6971.6401-1.9191 1.4975.2417.0355.4296.235.4296.4859zm6.3381-2.8977L7.9112.3284a.219.219 0 0 1 0-.2189A.2384.2384 0 0 1 8.098 0a.219.219 0 0 1 .1867.1094l1.0496 1.8158a6.4907 6.4907 0 0 1 5.3186 0L15.696.1094a.2189.2189 0 0 1 .3734.2189l-1.0302 1.79c1.6671.9125 2.7974 2.5439 3.0975 4.4018l-12.286-.0014c.3004-1.8572 1.4305-3.488 3.0972-4.4003zm5.3774 2.6202a.515.515 0 0 0 .5271.5028.515.515 0 0 0 .5151-.5151.5213.5213 0 0 0-.8885-.367.5151.5151 0 0 0-.1537.3793zm-5.7178-.0067a.5151.5151 0 0 0 .5207.5095.5086.5086 0 0 0 .367-.1481.5215.5215 0 1 0-.734-.7341.515.515 0 0 0-.1537.3727z',
  python: 'M14.25.18l.9.2.73.26.59.3.45.32.34.34.25.34.16.33.1.3.04.26.02.2-.01.13V8.5l-.05.63-.13.55-.21.46-.26.38-.3.31-.33.25-.35.19-.35.14-.33.1-.3.07-.26.04-.21.02H8.77l-.69.05-.59.14-.5.22-.41.27-.33.32-.27.35-.2.36-.15.37-.1.35-.07.32-.04.27-.02.21v3.06H3.17l-.21-.03-.28-.07-.32-.12-.35-.18-.36-.26-.36-.36-.35-.46-.32-.59-.28-.73-.21-.88-.14-1.05-.05-1.23.06-1.22.16-1.04.24-.87.32-.71.36-.57.4-.44.42-.33.42-.24.4-.16.36-.1.32-.05.24-.01h.16l.06.01h8.16v-.83H6.18l-.01-2.75-.02-.37.05-.34.11-.31.17-.28.25-.26.31-.23.38-.2.44-.18.51-.15.58-.12.64-.1.71-.06.77-.04.84-.02 1.27.05zm-6.3 1.98l-.23.33-.08.41.08.41.23.34.33.22.41.09.41-.09.33-.22.23-.34.08-.41-.08-.41-.23-.33-.33-.22-.41-.09-.41.09zm13.09 3.95l.28.06.32.12.35.18.36.27.36.35.35.47.32.59.28.73.21.88.14 1.04.05 1.23-.06 1.23-.16 1.04-.24.86-.32.71-.36.57-.4.45-.42.33-.42.24-.4.16-.36.09-.32.05-.24.02-.16-.01h-8.22v.82h5.84l.01 2.76.02.36-.05.34-.11.31-.17.29-.25.25-.31.24-.38.2-.44.17-.51.15-.58.13-.64.09-.71.07-.77.04-.84.01-1.27-.04-1.07-.14-.9-.2-.73-.25-.59-.3-.45-.33-.34-.34-.25-.34-.16-.33-.1-.3-.04-.25-.02-.2.01-.13v-5.34l.05-.64.13-.54.21-.46.26-.38.3-.32.33-.24.35-.2.35-.14.33-.1.3-.06.26-.04.21-.02.13-.01h5.84l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.47 14.25l-.23.33-.08.41.08.41.23.33.33.23.41.08.41-.08.33-.23.23-.33.08-.41-.08-.41-.23-.33-.33-.23-.41-.08-.41.08z',
};

const BrandIcon = ({ path, color, className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" className={className} fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d={path} />
  </svg>
);

const AwsLogo = ({ className = 'h-7' }) => (
  <svg viewBox="0 0 64 34" className={className} xmlns="http://www.w3.org/2000/svg">
    <text x="32" y="18" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="18" fill="#232F3E">aws</text>
    <path d="M10 25 C24 33 40 33 54 25" fill="none" stroke="#FF9900" strokeWidth="2.6" strokeLinecap="round" />
    <path d="M51 22.5 L55 25.2 L50.6 27.4" fill="none" stroke="#FF9900" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AiSpinner = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g className="se-spin" style={{ transformOrigin: 'center' }}>
      <path d="M12 2.5 A9.5 9.5 0 0 1 21.5 12" stroke="#3284c7" strokeWidth="3" strokeLinecap="round" />
      <path d="M21.5 12 A9.5 9.5 0 0 1 12 21.5" stroke="#f29132" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 21.5 A9.5 9.5 0 0 1 2.5 12" stroke="#16a34a" strokeWidth="3" strokeLinecap="round" />
      <path d="M2.5 12 A9.5 9.5 0 0 1 12 2.5" stroke="#9333ea" strokeWidth="3" strokeLinecap="round" />
    </g>
  </svg>
);

/* Real SmartEdz brand mark (matches the navbar/footer logo: PNG icon + gradient wordmark) */
const BrandMark = ({ variant = 'gradient', imgClass = 'h-4', textClass = 'text-[10px]' }) => (
  <span className="inline-flex items-center gap-1 leading-none">
    <img
      src="/smartedzmain.png"
      alt="SmartEdz"
      className={`${imgClass} w-auto object-contain`}
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
    />
    <span className={`${textClass} font-bold tracking-tight leading-none`}>
      {variant === 'white' ? (
        <span className="text-white">SmartEdz</span>
      ) : (
        <>
          <span className="bg-gradient-to-t from-[#18469A] via-[#1B83C5] to-[#21BEE1] bg-clip-text text-transparent">Smart</span>
          <span className="bg-gradient-to-t from-[#E35D14] to-[#F4A51D] bg-clip-text text-transparent">Edz</span>
        </>
      )}
    </span>
  </span>
);

/* ============================== DATA ============================== */

const PLATFORMS = [
  { label: 'Android', render: <BrandIcon path={PATHS.android} color="#3DDC84" className="w-5 h-5" /> },
  { label: 'iOS', render: <BrandIcon path={PATHS.apple} color="#111827" className="w-5 h-5" /> },
  { label: 'Web', render: <Globe className="w-5 h-5 text-primary" /> },
  { label: 'AI', render: <AiSpinner className="w-5 h-5" /> },
  { label: 'Cloud', render: <Cloud className="w-5 h-5 text-sky-500" /> },
];

const TRUST = ['Secure', 'Scalable', 'Reliable', 'Future-Ready'];

const TECHS = [
  { label: 'React', color: '#61DAFB', render: <BrandIcon path={PATHS.react} color="#61DAFB" className="w-8 h-8" /> },
  { label: 'TypeScript', color: '#3178C6', render: <BrandIcon path={PATHS.typescript} color="#3178C6" className="w-8 h-8" /> },
  { label: 'Node.js', color: '#5FA04E', render: <BrandIcon path={PATHS.node} color="#5FA04E" className="w-8 h-8" /> },
  { label: 'Android Studio', color: '#3DDC84', render: <BrandIcon path={PATHS.androidstudio} color="#3DDC84" className="w-8 h-8" /> },
  { label: 'React Native', color: '#61DAFB', render: <BrandIcon path={PATHS.react} color="#61DAFB" className="w-8 h-8" /> },
  { label: '', color: '', render: <AwsLogo className="h-8" /> },
  { label: 'MySQL', color: '#00618A', render: <BrandIcon path={PATHS.mysql} color="#00618A" className="w-8 h-8" /> },
  { label: 'Python', color: '#3776AB', render: <BrandIcon path={PATHS.python} color="#3776AB" className="w-8 h-8" /> },
];

const INDUSTRIES = [
  { Icon: GraduationCap, title: 'Education', desc: 'Schools, Colleges, Universities, LMS', color: '#3284c7' },
  { Icon: HeartPulse, title: 'Healthcare', desc: 'Hospitals, Clinics, Pharmacies', color: '#16a34a' },
  { Icon: Factory, title: 'Manufacturing', desc: 'Factories, Production, Quality Control', color: '#9333ea' },
  { Icon: ShoppingCart, title: 'Retail & POS', desc: 'Retail Stores, Chains, POS Solutions', color: '#f29132' },
  { Icon: Truck, title: 'Logistics', desc: 'Transport, Fleet, Warehouse', color: '#0d9488' },
  { Icon: Coins, title: 'Finance', desc: 'Accounting, Billing, Payroll, GST', color: '#eab308' },
];

const PRODUCTS = [
  { Icon: GraduationCap, title: 'Education ERP', color: '#3284c7', to: '/Educationerp',
    features: ['Admission Management', 'Attendance', 'Examinations', 'Fees Management', 'Transport', 'Library', 'Hostel', 'HR & Payroll'] },
  { Icon: HeartPulse, title: 'Hospital ERP', color: '#16a34a', to: '/Hospitalerp',
    features: ['OPD & IPD', 'Patient Management', 'Pharmacy', 'Laboratory', 'Radiology', 'Billing & Insurance', 'EMR', 'Ambulance'] },
  { Icon: Users, title: 'HRMS', color: '#9333ea', to: '/HRMS',
    features: ['Employee Management', 'Attendance', 'Payroll', 'Leave Management', 'Recruitment', 'Performance', 'Training'] },
  { Icon: Target, title: 'CRM', color: '#f29132', to: '/CRM',
    features: ['Leads Management', 'Sales Automation', 'Customer Management', 'Marketing', 'Follow-ups', 'Reports & Analytics'] },
  { Icon: Boxes, title: 'Inventory ERP', color: '#0d9488', to: '/Inventoryerp',
    features: ['Stock Management', 'Purchase & Sales', 'Warehouse', 'Multi-Location', 'Barcode / QR Code', 'Reports'] },
  { Icon: Puzzle, title: 'Custom ERP', color: '#3284c7', to: '/Customerp',
    features: ['Custom Workflows', 'Role Based Access', 'Scalable & Secure', 'API Integration', 'AI & Automation', 'Cloud Ready'] },
];

const WHY = [
  { Icon: Code2, title: 'Custom Solutions', desc: 'Tailored software for your unique needs' },
  { Icon: MonitorSmartphone, title: 'Cross Platform', desc: 'Android, iOS & Web – one seamless experience' },
  { Icon: Cpu, title: 'AI Powered', desc: 'Intelligent automation for better decisions' },
  { Icon: Cloud, title: 'Cloud Ready', desc: 'Secure, scalable & high performance' },
  { Icon: Users, title: 'Expert Team', desc: 'Experienced developers & domain experts' },
  { Icon: Headphones, title: '24/7 Support', desc: "We're here to support you anytime" },
];



const CONTAINER = 'w-full max-w-7xl xl:max-w-[95%] 2xl:max-w-[85vw] mx-auto px-6 sm:px-8 lg:px-8';

/* ============================== HELPERS ============================== */

function Reveal({ children, className = '', delay = 0 }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) { setShown(true); io.disconnect(); } },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={className}
      style={{ opacity: shown ? 1 : 0, transform: shown ? 'translateY(0)' : 'translateY(28px)',
        transition: `opacity .7s ease ${delay}ms, transform .7s ease ${delay}ms` }}>
      {children}
    </div>
  );
}

function StatItem({ Icon, value, suffix = '', decimals = 0, label }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf;
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        const dur = 1600, t0 = performance.now();
        const tick = (now) => {
          const p = Math.min((now - t0) / dur, 1);
          setN(value * (1 - Math.pow(1 - p, 3)));
          if (p < 1) raf = requestAnimationFrame(tick); else setN(value);
        };
        raf = requestAnimationFrame(tick);
        io.disconnect();
      }
    }, { threshold: 0.4 });
    io.observe(el);
    return () => { io.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, [value]);
  const display = decimals ? n.toFixed(decimals) : Math.round(n).toString();
  return (
    <div ref={ref} className="flex items-center justify-center gap-3">
      <div className="w-11 h-11 rounded-xl bg-white/10 ring-1 ring-white/15 flex items-center justify-center shrink-0">
        <Icon className="w-5 h-5 text-white/90" />
      </div>
      <div className="text-left">
        <div className="text-2xl sm:text-3xl font-extrabold text-white leading-none">{display}{suffix}</div>
        <div className="text-xs text-slate-300 mt-1">{label}</div>
      </div>
    </div>
  );
}

function SectionHead({ eyebrow, title }) {
  return (
    <div className="text-center mb-10">
      <span className="block text-xs font-bold tracking-[0.2em] uppercase text-primary mb-3">{eyebrow}</span>
      <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ color: '#13294b' }}>{title}</h2>
    </div>
  );
}

/* ============================== DASHBOARD GRAPHS ============================== */

const AreaChart = ({ className, id = 'a' }) => (
  <svg viewBox="0 0 320 120" className={className} preserveAspectRatio="none">
    <defs>
      <linearGradient id={`seArea-${id}`} x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#3284c7" stopOpacity="0.32" />
        <stop offset="100%" stopColor="#3284c7" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path d="M0,96 C24,88 40,70 60,74 C82,78 96,52 118,58 C140,64 152,40 176,48 C198,55 214,30 240,34 C262,37 278,18 300,22 C310,24 316,20 320,18 L320,120 L0,120 Z" fill={`url(#seArea-${id})`} />
    <path d="M0,96 C24,88 40,70 60,74 C82,78 96,52 118,58 C140,64 152,40 176,48 C198,55 214,30 240,34 C262,37 278,18 300,22 C310,24 316,20 320,18" fill="none" stroke="#3284c7" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="240" cy="34" r="4" fill="#fff" stroke="#3284c7" strokeWidth="2.5" />
  </svg>
);

const DonutChart = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className}>
    <circle cx="50" cy="50" r="33" fill="none" stroke="#eef2f7" strokeWidth="15" />
    <circle cx="50" cy="50" r="33" fill="none" stroke="#3284c7" strokeWidth="15" strokeLinecap="round" strokeDasharray="207.3" strokeDashoffset="72" transform="rotate(-90 50 50)" />
    <circle cx="50" cy="50" r="33" fill="none" stroke="#f29132" strokeWidth="15" strokeLinecap="round" strokeDasharray="207.3" strokeDashoffset="150" transform="rotate(120 50 50)" />
    <circle cx="50" cy="50" r="33" fill="none" stroke="#e11d48" strokeWidth="15" strokeLinecap="round" strokeDasharray="207.3" strokeDashoffset="186" transform="rotate(235 50 50)" />
  </svg>
);

const LEGEND = [
  { c: '#3284c7', t: 'Students' },
  { c: '#f29132', t: 'Attendance' },
  { c: '#e11d48', t: 'Fees' },
  { c: '#16a34a', t: 'Others' },
];

const LaptopMock = () => (
  <div className="w-full">
    <div className="bg-[#0f172a] rounded-t-[14px] rounded-b-md p-2 shadow-2xl">
      <div className="bg-white rounded-md overflow-hidden flex" style={{ minHeight: 300 }}>
        {/* sidebar */}
        <div className="w-[22%] bg-[#0f2350] py-3 px-2 flex flex-col gap-1">
          <div className="mb-2 px-1"><BrandMark variant="white" imgClass="h-4" textClass="text-[9px]" /></div>
          {[
            { Icon: LayoutGrid, label: 'Dashboard', active: true },
            { Icon: Users, label: 'Students' },
            { Icon: GraduationCap, label: 'Academics' },
            { Icon: CalendarDays, label: 'Attendance' },
            { Icon: FileText, label: 'Examinations' },
            { Icon: BookOpen, label: 'Library' },
            { Icon: Bus, label: 'Transport' },
            { Icon: Coins, label: 'Fees' },
            { Icon: Settings, label: 'Settings' },
          ].map((m, i) => (
            <div key={i} className={`flex items-center gap-1.5 rounded-md px-1.5 py-[3px] ${m.active ? 'bg-white/10' : ''}`}>
              <m.Icon className={`w-2.5 h-2.5 shrink-0 ${m.active ? 'text-[#21BEE1]' : 'text-white/50'}`} />
              <span className={`text-[7px] font-medium leading-none whitespace-nowrap ${m.active ? 'text-white' : 'text-white/60'}`}>{m.label}</span>
            </div>
          ))}
        </div>
        {/* main */}
        <div className="flex-1 p-3">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-1 bg-slate-100 rounded px-2 py-1 w-1/2">
              <Search className="w-2.5 h-2.5 text-slate-400" />
              <span className="h-1.5 w-full rounded bg-slate-200" />
            </div>
            <div className="flex items-center gap-1.5 text-slate-400">
              <Settings className="w-3 h-3" /><Bell className="w-3 h-3" />
              <span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#18469A] to-[#21BEE1]" />
            </div>
          </div>
          <div className="flex items-center justify-between mb-2.5">
            <span className="text-[11px] font-bold text-slate-800">Dashboard</span>
            <span className="text-[7px] text-white bg-primary rounded px-2 py-1">Get Started</span>
          </div>
          <div className="grid grid-cols-4 gap-2 mb-3">
            {[['Total Users', '32,680', '#3284c7'], ['Revenue', '\u20B924.5M', '#16a34a'], ['Orders', '8,540', '#0ea5e9'], ['Growth', '+24.5%', '#f29132']].map(([k, v, c]) => (
              <div key={k} className="rounded-md ring-1 ring-slate-100 bg-white p-2 border-l-2" style={{ borderColor: c }}>
                <div className="text-[6.5px] text-slate-400">{k}</div>
                <div className="text-[10px] font-bold text-slate-800">{v}</div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-5 gap-2 mb-3">
            <div className="col-span-3 rounded-md ring-1 ring-slate-100 bg-white p-2">
              <div className="text-[7.5px] font-semibold text-slate-600 mb-1">Revenue Overview</div>
              <AreaChart id="laptop" className="w-full h-16" />
            </div>
            <div className="col-span-2 rounded-md ring-1 ring-slate-100 bg-white p-2">
              <div className="text-[7.5px] font-semibold text-slate-600 mb-1">Recent Overview</div>
              <div className="flex items-center gap-2">
                <DonutChart className="w-14 h-14 shrink-0" />
                <div className="space-y-1">
                  {LEGEND.map((l) => (
                    <div key={l.t} className="flex items-center gap-1">
                      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: l.c }} />
                      <span className="text-[6px] text-slate-500">{l.t}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="rounded-md ring-1 ring-slate-100 bg-white p-2">
              <div className="text-[7.5px] font-semibold text-slate-600 mb-1.5">Recent Activities</div>
              {[0, 1].map((i) => (
                <div key={i} className="flex items-center gap-1.5 mb-1.5">
                  <span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#18469A] to-[#21BEE1] shrink-0" />
                  <div className="flex-1 space-y-0.5">
                    <span className="block h-1.5 rounded bg-slate-200 w-5/6" />
                    <span className="block h-1 rounded bg-slate-100 w-1/2" />
                  </div>
                </div>
              ))}
            </div>
            <div className="rounded-md ring-1 ring-slate-100 bg-white p-2">
              <div className="text-[7.5px] font-semibold text-slate-600 mb-1.5">Revenue</div>
              {[0, 1].map((i) => (
                <div key={i} className="flex items-center gap-1.5 mb-1.5">
                  <span className="w-4 h-4 rounded bg-green-100 shrink-0" />
                  <div className="flex-1 space-y-0.5">
                    <span className="block h-1.5 rounded bg-slate-200 w-4/6" />
                    <span className="block h-1 rounded bg-slate-100 w-2/5" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="mx-auto h-3 w-[112%] -ml-[6%] bg-gradient-to-b from-[#cbd5e1] to-[#94a3b8] rounded-b-xl" />
    <div className="mx-auto h-1 w-[26%] bg-[#94a3b8] rounded-b" />
  </div>
);

const TABLET_APPS = [
  { Icon: UserSquare2, label: 'Students', color: '#f29132' },
  { Icon: Users, label: 'Employees', color: '#3284c7' },
  { Icon: CalendarDays, label: 'Attendance', color: '#f29132' },
  { Icon: FileText, label: 'Examinations', color: '#0ea5e9' },
  { Icon: LayoutGrid, label: 'Library', color: '#e11d48' },
  { Icon: BookOpen, label: 'Library', color: '#16a34a' },
  { Icon: Bus, label: 'Transport', color: '#9333ea' },
  { Icon: FileText, label: 'Reports', color: '#f59e0b' },
];

const TabletMock = () => (
  <div className="bg-[#0f172a] rounded-[22px] p-2.5 shadow-2xl w-full">
    <div className="bg-white rounded-2xl overflow-hidden p-3.5">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[10px] font-bold text-slate-700">Quick Access</span>
        <div className="flex gap-1 text-slate-300"><Settings className="w-3 h-3" /><Bell className="w-3 h-3" /></div>
      </div>
      <div className="grid grid-cols-4 gap-3">
        {TABLET_APPS.map((a, i) => (
          <div key={i} className="flex flex-col items-center gap-1">
            <span className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{ backgroundColor: `${a.color}1A` }}>
              <a.Icon className="w-5 h-5" style={{ color: a.color }} />
            </span>
            <span className="text-[6.5px] text-slate-500">{a.label}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const PhoneMock = () => (
  <div className="bg-[#0f172a] rounded-[26px] p-1.5 shadow-2xl w-full ring-1 ring-black/20">
    <div className="bg-white rounded-[22px] overflow-hidden">
      <div className="relative h-5 bg-white">
        <span className="absolute left-1/2 -translate-x-1/2 top-1.5 w-12 h-1.5 rounded-full bg-slate-900" />
      </div>
      <div className="px-3 pb-3">
        <div className="flex items-center justify-between mb-2">
          <BrandMark variant="gradient" imgClass="h-4" textClass="text-[9px]" />
          <Bell className="w-3 h-3 text-slate-300" />
        </div>
        <div className="text-[10px] font-bold text-slate-800 mb-2">Dashboard</div>
        <div className="grid grid-cols-2 gap-2 mb-2.5">
          {[['Users', '33,680', '#3284c7'], ['Revenue', '\u20B924.5M', '#9333ea'], ['Orders', '8,540', '#f29132'], ['Growth', '+24.5%', '#16a34a']].map(([k, v, c]) => (
            <div key={k} className="rounded-lg ring-1 ring-slate-100 bg-white p-2 border-l-2" style={{ borderColor: c }}>
              <div className="text-[6.5px] text-slate-400">{k}</div>
              <div className="text-[9px] font-bold text-slate-800">{v}</div>
            </div>
          ))}
        </div>
        <div className="rounded-lg ring-1 ring-slate-100 p-2">
          <div className="text-[7px] font-semibold text-slate-500 mb-1">Revenue Overview</div>
          <AreaChart id="phone" className="w-full h-14" />
        </div>
      </div>
    </div>
  </div>
);

const DeviceShowcase = () => (
  <div className="relative w-full max-w-[760px] mx-auto pb-6 sm:pb-[24%]">
    <div className="absolute inset-x-8 top-4 bottom-16 bg-gradient-to-tr from-primary/12 to-[#21BEE1]/12 blur-3xl rounded-[48px]" />
    {/* Laptop (behind, centered) */}
    <div className="relative z-10 w-[82%] mx-auto">
      <LaptopMock />
    </div>
    {/* Tablet (front, bottom-left, overlapping laptop's lower-left) */}
    <div className="absolute z-20 w-[50%] left-0 bottom-0 se-float-slow hidden sm:block">
      <TabletMock />
    </div>
    {/* Phone (front, bottom-right, big & prominent) */}
    <div className="absolute z-30 w-[28%] right-0 bottom-0 se-float hidden sm:block">
      <PhoneMock />
    </div>
  </div>
);

/* ============================== SECTIONS ============================== */

function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef4fb] via-[#f5f9fd] to-white">
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -left-24 w-80 h-80 rounded-full bg-[#f29132]/10 blur-3xl" />
      <div className={`${CONTAINER} relative py-12 lg:py-16`}>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-8 items-center">
          <div className="se-fade-up">
            <span className="inline-flex items-center text-xs font-bold tracking-[0.18em] uppercase text-primary bg-white ring-1 ring-primary/25 px-4 py-1.5 rounded-full">
              Software Development Company
            </span>

            <h1 className="mt-6 text-4xl sm:text-5xl xl:text-[3.7rem] font-extrabold leading-[1.08] tracking-tight" style={{ color: '#13294b' }}>
            Empowering Digital Transformation with smart Software Solutions
            </h1>

            <p className="mt-6 text-lg text-slate-500 max-w-xl leading-relaxed">
              SmartEdz empowers businesses with intelligent ERP solutions, custom software, mobile applications, web platforms, and AI-driven technologies that streamline operations, accelerate growth, and drive digital transformation.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              {PLATFORMS.map((p) => (
                <span key={p.label} className="inline-flex items-center gap-2 bg-white ring-1 ring-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition">
                  {p.render}{p.label}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/request-demo" className="inline-flex items-center gap-2 rounded-lg px-7 py-3.5 font-semibold text-white shadow-lg shadow-primary/30 bg-primary hover:brightness-110 transition">
                Request Demo <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/contact-us" className="inline-flex items-center gap-2 rounded-lg px-7 py-3.5 font-semibold text-primary bg-white ring-1 ring-primary/40 hover:bg-primary/5 transition">
                Start Your Project <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3 text-sm text-slate-500">
              <ShieldCheck className="w-4 h-4 text-[#13294b]" />
              {TRUST.map((t, i) => (
                <React.Fragment key={t}>
                  <span className="font-medium">{t}</span>
                  {i < TRUST.length - 1 && <span className="text-slate-300">|</span>}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="se-fade-up" style={{ animationDelay: '.15s' }}>
            <DeviceShowcase />
          </div>
        </div>
      </div>
    </section>
  );
}

function TechStrip() {
  return (
    <section className="bg-gradient-to-b from-white to-[#f5f9fd] pb-10 -mt-4">
      <div className={CONTAINER}>
        <Reveal className="rounded-2xl ring-1 ring-slate-200 bg-white shadow-sm px-6 py-8">
          <p className="text-center text-base font-bold text-slate-800 mb-7">Powered By Modern Technologies</p>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-7">
            {TECHS.map((t, i) => (
              <div key={i} className="flex items-center gap-2 opacity-90 hover:opacity-100 transition">
                {t.render}
                {t.label && <span className="text-lg font-bold" style={{ color: t.color }}>{t.label}</span>}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function IndustriesSection() {
  return (
    <section className="bg-[#f5f9fd] py-14">
      <div className={CONTAINER}>
        <Reveal><SectionHead eyebrow="Industries We Serve" title="Software Solutions for Every Industry" /></Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-5 items-stretch">
          {INDUSTRIES.map((it, i) => (
            <Reveal key={it.title} delay={i * 60}>
              <div className="group h-full bg-white rounded-2xl ring-1 ring-slate-100 p-6 text-center shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="w-14 h-14 mx-auto rounded-2xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110" style={{ backgroundColor: `${it.color}1A` }}>
                  <it.Icon className="w-7 h-7" style={{ color: it.color }} />
                </div>
                <h3 className="font-bold text-slate-800 mb-1.5">{it.title}</h3>
                <p className="text-xs text-slate-500 leading-relaxed">{it.desc}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={INDUSTRIES.length * 60}>
            <Link to="/industries" className="group h-full flex flex-col items-center justify-center gap-3 text-center">
              <span className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white shadow-lg shadow-primary/30 group-hover:scale-110 transition-transform">
                <ChevronRight className="w-6 h-6" />
              </span>
              <span className="text-sm font-semibold text-primary leading-tight">View All<br />Industries</span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function ProductsSection() {
  return (
    <section className="bg-gradient-to-b from-[#f5f9fd] to-white py-14">
      <div className={CONTAINER}>
        <Reveal><SectionHead eyebrow="Our Products" title="Powerful Products to Run Your Entire Business" /></Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 70}>
              <div className="group h-full flex flex-col bg-white rounded-2xl ring-1 ring-slate-100 p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110" style={{ backgroundColor: `${p.color}1A` }}>
                  <p.Icon className="w-6 h-6" style={{ color: p.color }} />
                </div>
                <h3 className="font-bold text-slate-800 text-lg text-center mb-4">{p.title}</h3>
                <ul className="space-y-2 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-[13px] text-slate-500">
                      <span className="mt-[7px] w-1 h-1 rounded-full shrink-0" style={{ backgroundColor: p.color }} />
                      {f}
                    </li>
                  ))}
                </ul>
                {/* Changed <Link> to <a> for native hash routing support */}
                <a href={p.to} className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:gap-2.5 transition-all">
                  Explore <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function WhyChooseSection() {
  return (
    <section className="bg-white py-14">
      <div className={CONTAINER}>
        <Reveal><SectionHead eyebrow="Why Choose SmartEdz?" title="We Build Solutions That Drive Growth" /></Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-8">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={i * 60}>
              <div className="group text-center">
                <div className="w-16 h-16 mx-auto rounded-full ring-1 ring-slate-200 bg-white flex items-center justify-center mb-4 shadow-sm group-hover:bg-primary group-hover:ring-primary group-hover:scale-110 transition-all">
                  <w.Icon className="w-7 h-7 text-primary group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-bold text-slate-800 mb-1.5">{w.title}</h3>
                <p className="text-xs text-slate-500 leading-relaxed max-w-[160px] mx-auto">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}



/* ============================== PAGE ============================== */

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      <style>{`
        @keyframes seFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
        @keyframes seFloatSlow { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-9px)} }
        @keyframes seFadeUp { from{opacity:0;transform:translateY(26px)} to{opacity:1;transform:translateY(0)} }
        @keyframes seSpin { to { transform: rotate(360deg); } }
        .se-float { animation: seFloat 6s ease-in-out infinite; }
        .se-float-slow { animation: seFloatSlow 8s ease-in-out infinite; }
        .se-fade-up { animation: seFadeUp .8s ease-out both; }
        .se-spin { animation: seSpin 3.2s linear infinite; }
        @media (prefers-reduced-motion: reduce) {
          .se-float, .se-float-slow, .se-fade-up, .se-spin { animation: none !important; }
        }
      `}</style>

      <Hero />
      <TechStrip />
      <IndustriesSection />
      <ProductsSection />
      <WhyChooseSection />
      
    </div>
  );
};

export default Home;